import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable, Injector, NgZone } from '@angular/core';
import { AlertService } from '../services/alert.service';

@Injectable()
export class GlobalHandlerError implements ErrorHandler {
  constructor(private zone: NgZone, private injector: Injector) {}

  handleError(error: HttpErrorResponse | Error): void {
    const alertService = this.injector.get(AlertService);

    console.error('GlobalHandlerError =>', error);

    if (error instanceof HttpErrorResponse) {
      const errorDetails = this.getDetailsError(error);

      this.zone.run(() =>
        alertService.exibirError('Ocorreu um erro na requisição!', errorDetails)
      );
    }
  }

  private getDetailsError(err: HttpErrorResponse) {
    let error = '';

    if (!err.error) {
      return error;
    }

    const { errors } = err.error;

    if (errors && errors.length > 0) {
      const { message } = errors.pop();
      if (message) {
        error = message.replace(/\r\n/g, '<br>');
      }
    }

    return error;
  }
}
